import Tabs from 'components/SearchPlugin/Tabs';
import { useLoadShareableLinks } from 'hooks/useShareableLinks';
import MainLayout from 'pages/layout/MainLayout';
import { useEffect } from 'react';
import useUserStore from 'store/useUserStore';
import { useUtilsStore } from 'store/useUtilsStore';
import ClientPool from './client-pool';
import CompetitorsTab from './competitors';
import OverViewTab from './overview';
import SaveListingPage from './savelisting';
import IframePage from 'pages/IframePage';
import AdvancedAiSearch from './advanced-ai-search';
import CatastroSearchPage from './catastro-search';
import { motion, AnimatePresence } from 'framer-motion';

const MainPage = () => {
    const { topTabIndex, setTopTabIndex } = useUtilsStore();
    const { userInfo } = useUserStore();

    useLoadShareableLinks();

    // Route protection: redirect personal users away from BuyerPool (index 4)
    useEffect(() => {
        if (topTabIndex === 4 && userInfo?.accountType === 'Personal') {
            setTopTabIndex(0); // Redirect to Overview tab
        }
    }, [topTabIndex, userInfo?.accountType, setTopTabIndex]);

    const pageVariants = {
        initial: {
            opacity: 0,
            x: 20,
        },
        animate: {
            opacity: 1,
            x: 0,
        },
        exit: {
            opacity: 0,
            x: -20,
        },
    };

    const pageTransition = {
        type: 'tween',
        ease: 'anticipate',
        duration: 0.3,
    };

    return (
        <MainLayout>
            <div className="lg:max-w-hello mx-auto">
                <AnimatePresence mode="wait">
                    {topTabIndex === 0 && (
                        <motion.div key="overview" initial="initial" animate="animate" exit="exit" variants={pageVariants} transition={pageTransition}>
                            <OverViewTab />
                        </motion.div>
                    )}

                    {topTabIndex === 1 && (
                        <motion.div key="competitors" initial="initial" animate="animate" exit="exit" variants={pageVariants} transition={pageTransition}>
                            <CompetitorsTab />
                        </motion.div>
                    )}
                </AnimatePresence>
            </div>

            <AnimatePresence mode="wait">
                {topTabIndex === 2 && (
                    <motion.div key="savelisting" initial="initial" animate="animate" exit="exit" variants={pageVariants} transition={pageTransition}>
                        <SaveListingPage />
                    </motion.div>
                )}

                {topTabIndex === 3 && (
                    <motion.div key="tabs" initial="initial" animate="animate" exit="exit" variants={pageVariants} transition={pageTransition}>
                        <Tabs />
                    </motion.div>
                )}

                {topTabIndex === 4 && userInfo?.accountType === 'business' && (
                    <motion.div key="clientpool" initial="initial" animate="animate" exit="exit" variants={pageVariants} transition={pageTransition}>
                        <ClientPool />
                    </motion.div>
                )}

                {topTabIndex === 5 && (
                    <motion.div key="ai-search" initial="initial" animate="animate" exit="exit" variants={pageVariants} transition={pageTransition}>
                        <AdvancedAiSearch />
                    </motion.div>
                )}

                {topTabIndex === 6 && (
                    <motion.div key="catastro-search" initial="initial" animate="animate" exit="exit" variants={pageVariants} transition={pageTransition}>
                        <CatastroSearchPage />
                    </motion.div>
                )}
            </AnimatePresence>
        </MainLayout>
    );
};

export default MainPage;
